module.exports = __webpack_public_path__ + "static/media/cloud-drizzle.fc9e6384.svg";